import { useMutation, UseMutationResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';

const deleteDealUser = async ({
	userId,
	dealId,
	options,
}: {
	userId: string;
	dealId: string;
	options?: ServiceRequestOptions;
}) => {
	const response = await makeRequest<ApiV1.Response<void>>(
		{
			endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_USERS_USERID_DELETE, {
				userId,
				dealId,
			}),
			method: HTTP_METHOD.DELETE,
		},
		options
	);
	return response;
};

export const useDeleteDealUser = (): UseMutationResult<
	ApiV1.Response<void>,
	unknown,
	{ dealId: string; userId: string }
> => {
	return useMutation({
		mutationFn: deleteDealUser,
	});
};
